var React = require('react');
import { Box, Container, Grid } from '@mui/material';
import MUIDataTable from 'mui-datatables';
import DeleteIcon from "@material-ui/icons/Delete";
import SearchIcon from "@material-ui/icons/Search";
import SaveIcon from "@material-ui/icons/Save";
import IconButton from '@mui/material/IconButton';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Typography from '@mui/material/Typography';
import {MuiThemeProvider } from '@material-ui/core/styles';
import AddUserDialog from './CreateDialogue/AddUserDialog';
import EditUserDialog from './EditDialogue/EditUserDialog';
import { muiThemeDesign } from '../mui-theme-design';
import Tooltip from '@mui/material/Tooltip';
import Checkbox from '@mui/material/Checkbox';
import { makeStyles } from "@mui/styles";
import {logger, customBodyForExcelReport,handleExport,muiLoaderOptions} from '../utils';
import CheckIcon from '@mui/icons-material/Check';
import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb';
import moment from "moment";
const ExcelJS = require('exceljs');


const pageStyles = makeStyles(theme => ({
    error: {
        "& .MuiSvgIcon-root": {
            color: '#c40018 !important',
            fill: '#c40018 !important',
        },
    },
    root: {
        "& .MuiPaper-root": {
            overflowy: "hidden",
            color: '#ffffff'
        },
        "& .MuiSvgIcon-root": {
            color: '#ffffff',
            fill: '#ffffff'
        },
        "& .Mui-checked": {
            color: '#ffffff'
        },
        "& .MuiCheckBox-root": {
            color: '#ffffff'
        },
        "& .MuiCheckbox - colorPrimary": {
            color: '#ffffff'
        },
    }
}));

function UserListSearch() {
    const [refresh, setRefresh] = React.useState(true);
    const [dataSet, setDataSet] = React.useState([]);
    const [permissions, setPermissions] = React.useState({});
    const [expand, setExpand] = React.useState(false);
    const [Alert, setAlert] = React.useState(false);
    const [AlertText, setAlertText] = React.useState('');
    const [isLoading, setIsLoading] = React.useState(true);
    const classes = pageStyles();
    const timer = React.useRef(null);
    const [columns, setColumns] = React.useState([]);

    const handleAlertClose = () => {
        setAlert(false);
    };
 
 const loadUserList = async () => {
    try {
      const res = await fetch(`/api/Userlist/${expand}`);
      const json = await res.json();
      setDataSet(json);
      setIsLoading(false);
      return json;
    } catch (error) {
      console.error('Error loading UserList', error);
      setIsLoading(false);
    }
  };

  // Fetch user permissions
  const loadUserPermissions = async () => {
    try {
      const res = await fetch('/api/User/Permission');
      const json = await res.json();
      setPermissions(json);
      return json;
    } catch (error) {
      console.error('Error loading UserPermissions', error);
    }
  };

    const handleDialogCallback = (childData) => {
        fetch("/api/User", {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                "User": {
                    "firstName": childData.firstName,
                    "lastName": childData.lastName,
                    "Email": childData.Email,
                    "CostCenterID": childData.CostCenterID,
                    "Password": childData.Password,
                    "AssignedTo": childData.AssignedTo,
                    "AppRoleID": childData.AppRoleID,
                    "PayRate": childData.PayRate,
                    "IsActive": childData.IsActive
                },
                "user_prop_item": childData.PropList
            })
        }).then(res => res.json())
            .then(json => {
                json.error
                if (typeof json.error !== "undefined") {
                    setAlertText(json.error)
                    setAlert(true)
                }
            })
        logger('post', childData);
        setRefresh(true)
    };

    const handleEditCallback = (childData) => {
        fetch("/api/User", {
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                "User": {
                    "ID": childData.ID,
                    "firstName": childData.firstName,
                    "lastName": childData.lastName,
                    "Email": childData.Email,
                    "Password": childData.Password,
                    "CostCenterID": childData.CostCenterID,
                    "DefaultRole": childData.DefaultRole,
                    "AssignedTo": childData.AssignedTo,
                    "AppRoleID": childData.AppRoleID,
                    "PayRate": childData.PayRate,
                    "IsActive": childData.IsActive
                },
                "user_prop_item": childData.PropList
            })
        })
        logger('editCallback', childData);
        setRefresh(true)
    };
    const MakeToolbar = () => {
        return (
            <Grid container justifyContent="flex-end">
                <Grid item xs={4}> <AddUserDialog handleDialogCallback={handleDialogCallback} /></Grid>
                <Tooltip title="Include Unassigned Users" placement="top-end">
                    <Grid item xs={2}>  <Checkbox defaultChecked={expand} color="primary" className={classes.root} onClick={() => { setExpand(!expand), setRefresh(true); }} /></Grid>
                </Tooltip>
            </Grid>
        );
    }

 // Build columns dynamically based on permissions
  const buildColumns = (perm, data) => {
    const cols = [];

    if (perm.CreateUser === 1) {
      cols.push({
        name: 'Actions',
        options: {
          filter: false,
          sort: false,
          empty: true,
          print: false,
          customBodyRenderLite: (dataIndex) => {
            const user = data[dataIndex];

            // Clean up pay rate parsing
            let payRate = '';
            if (user?.PayRate) {
              if (user.PayRate.data && user.PayRate.data.length > 0) {
                const byteArray = new Uint8Array(user.PayRate.data);
                const textDecoder = new TextDecoder();
                payRate = parseFloat(textDecoder.decode(byteArray)).toFixed(2);
              } else if (!user.PayRate.data) {
                payRate = user.PayRate;
              }
            }

            const rateData = {
              ...user,
              PayRate: payRate || '',
            };

            return <EditUserDialog handleEditCallback={handleEditCallback} data={rateData} />;
          },
        },
      });
    }

    cols.push(
      {
        name: 'FirstName',
        label: 'First Name',
        options: { filter: true, sort: true },
      },
      {
        name: 'LastName',
        label: 'Last Name',
        options: { filter: true, sort: true },
      },
      {
        name: 'DefaultRole',
        label: 'Default Role',
        options: {
          filter: true,
          sort: true,
          customBodyRenderLite: (dataIndex) => {
            const user = data[dataIndex];
            var DefaultRole = user?.DefaultRole ? user?.DefaultRole : '';
            var DefaultRoleStatus = user?.DefaultRoleStatus ? user?.DefaultRoleStatus : '';
            var DefaultPositionStatus = user?.DefaultPositionStatus ? user?.DefaultPositionStatus : '';
            var DefaultPositionName = user?.DefaultPositionName ? user?.DefaultPositionName : '';
            var EndDate = user?.EndDate ? user?.EndDate : '';

            if (DefaultRoleStatus === 0) {
              return (
                <Tooltip title={`Default Role: ${DefaultRole} is Inactive`} placement="top-end">
                  <div style={{ color: 'red' }}>{DefaultRole}</div>
                </Tooltip>
              );
            }

            if (DefaultPositionStatus === 0) {
              return (
                <Tooltip title={`Position: ${DefaultPositionName} is Inactive`} placement="top-end">
                  <div style={{ color: 'red' }}>{DefaultRole}</div>
                </Tooltip>
              );
            }

            if (moment(EndDate).isSameOrBefore(moment())) {
              return (
                <Tooltip title={`Default Role: ${DefaultRole} has expired`} placement="top-end">
                  <div style={{ color: 'red' }}>{DefaultRole}</div>
                </Tooltip>
              );
            }

            return <Tooltip><div>{DefaultRole}</div></Tooltip>;
          },
        },
      },
      {
        name: 'PayRate',
        label: 'Pay Rate',
        options: {
          filter: false,
          sort: false,
          empty: true,
          print: false,
          customBodyRenderLite: (dataIndex) => {
            const user = data[dataIndex];
            let pay = '';

            if (user?.PayRate) {
              if (user.PayRate.data && user.PayRate.data.length > 0) {
                const byteArray = new Uint8Array(user.PayRate.data);
                const textDecoder = new TextDecoder();
                pay = parseFloat(textDecoder.decode(byteArray)).toFixed(2);
              } else if (!user.PayRate.data) {
                pay = user.PayRate;
              }
            }
            return pay || '';
          },
        },
      },
      {
        name: 'Email',
        label: 'Email',
        options: { filter: true, sort: true },
      },
      {
        name: 'Assigned',
        label: 'Assigned',
        options: { filter: true, sort: true },
      },
      {
        name: 'IsActive',
        options: {
          filter: true,
          sort: true,
          empty: true,
          filterList: [1],
          customFilterListOptions: {
            render: (v) => (v === 0 ? 'Show InActive' : v === 1 ? 'Show Active' : v),
          },
          filterOptions: {
            renderValue: (val) => (val === 0 ? 'InActive' : val === 1 ? 'Active' : val),
          },
          customBodyRenderLite: (dataIndex) => (
            <div>{data[dataIndex]?.IsActive ? <CheckIcon /> : <DoNotDisturbIcon />}</div>
          ),
        },
      }
    );

    return cols;
  };

  // Main data and permissions load + column setup
  React.useEffect(() => {
    if (!refresh) return;

    (async () => {
      try {
        const [users, perms] = await Promise.all([loadUserList(), loadUserPermissions()]);
        if (users && perms) {
          setColumns(buildColumns(perms, users));
          setRefresh(false);
        }
      } catch (error) {
        console.error('Error loading user data or permissions:', error);
      }
    })();
  }, [refresh, expand]);

	const getSavedRowsPerPage = () => {
		const savedValue = localStorage.getItem('UserLrowsPerPage');
		const parsedValue = parseInt(savedValue, 10);
		return Number.isInteger(parsedValue) ? parsedValue : 100; // Default value
	}
	// Save to local storage
	const saveRowsPerPage = (value) => {
		localStorage.setItem('UserLrowsPerPage', value.toString());
	}

	const initialRowsPerPage = getSavedRowsPerPage();

	const options = {
        filter: true,
        filterType: 'dropdown',
        fixedHeader: true,
        responsive: 'vertical',
        rowsPerPage: initialRowsPerPage, // Use the initial value retrieved from local storage
        rowsPerPageOptions: [10, 20, 50, 100],
        selectableRows: 'none',
         textLabels: {
			toolbar: {
			  search: "Search",
			  downloadCsv: "Download Excel", 
			  print: "Print",
			  viewColumns: "View Columns",
			  filterTable: "Filter Table",
				},
		},
       
		  onDownload: (buildHead, buildBody, columns, data) => {
			// Custom buildHead and buildBody functions
			const customBuildHead = () => {
				var newColumns = columns.map(column => column.label);
				return newColumns;
			}
		
			const customBuildBody = () => {
				const headers = customBuildHead();
				for (var i = 0; i < data.length; i++) {
					var eachRow = data[i].data;
					var payRate = eachRow[4];
					const byteArray = new Uint8Array(payRate.data);
					const textDecoder = new TextDecoder();
					const res = textDecoder.decode(byteArray);
					eachRow[4] = res;
				}
				return customBodyForExcelReport({data:data, headers:headers, columnIndexToRemove:0});
			};
			
			const headers = customBuildHead();
			const rows = customBuildBody();
			handleExport({rows:rows, headers:headers, filename:'UsersList.xlsx', columnIndexToRemove:0});
			return false;
		}
};
    
    if(permissions.CreateUser==1){
	   // const addUserDialog = ()=> (<AddUserDialog handleDialogCallback={handleDialogCallback} />);
	    options.customToolbar = MakeToolbar;
        selectableRows: 'none'
    };

    options.onChangeRowsPerPage = (newRowsPerPage) => {
        saveRowsPerPage(newRowsPerPage);
    };

    return (
        
        <Box>
            <MuiThemeProvider theme={muiThemeDesign}>
             <Box style={{ minHeight: '100vh' }}>
                <MUIDataTable className="userTable"
                    title={
                        <Typography variant="h6" style={{ color: "white" }}>
                            Beyondsoft Employee List
                        </Typography>
                    }
                    data={isLoading ? [] : dataSet}
                    columns={columns}
                    options={muiLoaderOptions(options, isLoading)}
                    
                />
                </Box>
            </MuiThemeProvider>
            <Dialog
                open={Alert}
                onClose={handleAlertClose}
                aria-labelledby="L&P Lock"
                aria-describedby="Time Period locked for this work"
            >
                <DialogTitle id="Time Entry">
                    {"Alert"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {AlertText}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => { setAlert(false) }} autoFocus>Close</Button>
                </DialogActions>
            </Dialog>
        </Box>

    );
}


export default UserListSearch